import React, { useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";

const Customers = () => {

  const navigate = useNavigate();

  const [customers, setCustomers] =
    useState([]);

  // =========================================
  // SEARCH + PAGINATION
  // =========================================

  const [searchTerm, setSearchTerm] =
    useState("");

  const [currentPage, setCurrentPage] =
    useState(1);

  const itemsPerPage = 20;

  // =========================================
  // FETCH CUSTOMERS
  // =========================================

  useEffect(() => {

    fetch(
      "/api/customers"
    )
      .then(res => res.json())
      .then(data => {

        setCustomers(

          Array.isArray(
            data.customers
          )

            ? data.customers

            : []
        );
      })
      .catch(err => {

        console.error(err);

        setCustomers([]);
      });

  }, []);

  // =========================================
  // FILTER CUSTOMERS
  // =========================================

  const filteredCustomers =
    customers.filter(c =>

      `${c.first_name}
      ${c.last_name}`

        .toLowerCase()

        .includes(
          searchTerm.toLowerCase()
        )

      ||

      (c.phone || "")
        .toLowerCase()
        .includes(
          searchTerm.toLowerCase()
        )

      ||

      (c.address || "")
        .toLowerCase()
        .includes(
          searchTerm.toLowerCase()
        )
    );

  // =========================================
  // PAGINATION
  // =========================================

  const indexOfLast =
    currentPage * itemsPerPage;

  const indexOfFirst =
    indexOfLast - itemsPerPage;

  const currentCustomers =
    filteredCustomers.slice(
      indexOfFirst,
      indexOfLast
    );

  const totalPages =
    Math.ceil(
      filteredCustomers.length /
      itemsPerPage
    );
    const handleDeleteCustomer = async (id) => {

  const confirmDelete = window.confirm(
    "Are you sure you want to delete this customer?"
  );

  if (!confirmDelete) return;

  try {

    const response = await fetch(
      `/api/customers/${id}`,
      {
        method: "DELETE",
      }
    );

    const data = await response.json();

    if (!response.ok) {
      alert(data.message);
      return;
    }

    alert(data.message);

    setCustomers(prev =>
      prev.filter(customer => customer.id !== id)
    );

  } catch (error) {

    console.error(error);

    alert("Server error");
  }
};

  return (

    <div className="min-h-screen bg-[#F5F7FB] p-4 md:p-6 space-y-6">

      {/* ========================================= */}
      {/* HERO */}
      {/* ========================================= */}

      <div className="bg-gradient-to-r from-indigo-600 to-purple-600 rounded-3xl p-5 md:p-8 text-white shadow-xl">

        <div className="flex flex-col lg:flex-row justify-between lg:items-center gap-6">

          <div>

            <p className="uppercase tracking-widest text-indigo-200 text-sm">

              Customer Management

            </p>

            <h1 className="text-2xl md:text-4xl font-bold mt-2">

              Customers

            </h1>

            <p className="mt-3 text-indigo-100">

              Manage customer profiles,
              rental history and account details.

            </p>

          </div>

          {/* STATS */}

          <div className="hidden md:flex flex-col items-end">

            <div className="bg-white/10 backdrop-blur-md px-6 py-4 rounded-2xl border border-white/20">

              <p className="text-sm text-indigo-100">

                Total Customers

              </p>

              <h2 className="text-4xl font-bold mt-1">

                {customers.length}

              </h2>

            </div>

          </div>

        </div>

      </div>

      {/* ========================================= */}
      {/* SEARCH + STATS */}
      {/* ========================================= */}

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">

        {/* SEARCH */}

        <div className="col-span-1 lg:col-span-8 bg-white rounded-3xl p-5 shadow-sm border border-gray-100">

          <div className="flex items-center gap-4">

            <div className="w-12 h-12 rounded-2xl bg-indigo-100 flex items-center justify-center text-xl">

              🔍

            </div>

            <input
              type="text"
              placeholder="Search customer name, phone or address..."
              value={searchTerm}
              onChange={(e) => {

                setSearchTerm(
                  e.target.value
                );

                setCurrentPage(1);
              }}
              className="w-full border border-gray-200 bg-gray-50 rounded-2xl px-5 py-4 outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition"
            />

          </div>

        </div>

        {/* CUSTOMER COUNT */}

        <div className="col-span-1 lg:col-span-4 bg-white rounded-3xl p-5 md:p-6 shadow-sm border border-gray-100">

          <div className="flex flex-col lg:flex-row justify-between lg:items-center gap-6">

            <div>

              <p className="text-sm text-gray-500">

                Filtered Results

              </p>

              <h2 className="text-3xl md:text-4xl font-bold text-indigo-600 mt-3">

                {filteredCustomers.length}

              </h2>

            </div>

            <div className="w-16 h-16 rounded-2xl bg-indigo-100 flex items-center justify-center text-3xl">

              👥

            </div>

          </div>

        </div>

      </div>

      {/* ========================================= */}
      {/* CUSTOMER TABLE */}
      {/* ========================================= */}

      <div className="bg-white rounded-3xl shadow-sm border border-gray-100 overflow-hidden">

        {/* HEADER */}

        <div className="px-5 md:px-8 py-6 border-b border-gray-100 flex flex-col sm:flex-row justify-between sm:items-center gap-4">

          <div>

            <h2 className="text-2xl font-bold text-gray-800">

              Customer Directory

            </h2>

            <p className="text-sm text-gray-500 mt-1">

              View and manage all rental customers

            </p>

          </div>

          <div className="bg-indigo-100 text-indigo-600 px-4 py-2 rounded-xl text-sm font-semibold">

            Active Customers

          </div>

        </div>

        {/* TABLE */}

        <div className="overflow-x-auto">

          <table className="min-w-[850px] w-full">

            {/* TABLE HEADER */}

            <thead className="bg-gray-50 text-gray-500 text-sm">

              <tr>

                <th className="text-left px-8 py-5">
                  Customer
                </th>

                <th className="text-left px-6 py-5">
                  Phone
                </th>

                <th className="text-left px-6 py-5">
                  Address
                </th>

                <th className="text-right px-8 py-5">
                  Actions
                </th>

              </tr>

            </thead>

            {/* TABLE BODY */}

            <tbody>

              {currentCustomers.length === 0 ? (

                <tr>

                  <td
                    colSpan="4"
                    className="py-20 text-center text-gray-500"
                  >

                    No customers found

                  </td>

                </tr>

              ) : (

                currentCustomers.map(c => (

                  <tr
                    key={c.id}
                    className="border-t border-gray-100 hover:bg-gray-50 cursor-pointer transition"
                    onClick={() =>
                      navigate(
                        `/customer/${c.id}`
                      )
                    }
                  >

                    {/* CUSTOMER */}

                    <td className="px-8 py-6">

                      <div className="flex items-center gap-4">

                        <div className="w-12 h-12 rounded-2xl bg-indigo-100 flex items-center justify-center font-bold text-indigo-600">

                          {
                            c.first_name?.charAt(0)
                          }

                        </div>

                        <div>

                          <p className="font-semibold text-gray-800 text-base">

                            {c.first_name}
                            {" "}
                            {c.last_name}

                          </p>

                          <p className="text-sm text-gray-500 mt-1">

                            Rental Customer

                          </p>

                        </div>

                      </div>

                    </td>

                    {/* PHONE */}

                    <td className="px-6 py-6 font-medium text-gray-700">

                      {c.phone || "-"}

                    </td>

                    {/* ADDRESS */}

                    <td className="px-6 py-6 text-gray-600">

                      {c.address || "-"}

                    </td>

                    {/* ACTIONS */}

                   <td className="px-8 py-6 text-right">

  <div className="flex justify-end gap-2 whitespace-nowrap">

    <button
      onClick={(e) => {

        e.stopPropagation();

        navigate(
          `/customer/${c.id}`
        );
      }}
      className="whitespace-nowrap bg-gradient-to-r from-indigo-600 to-purple-600 text-white px-5 py-3 rounded-2xl font-medium hover:shadow-lg transition"
    >
      View Details
    </button>

    <button
      onClick={(e) => {

        e.stopPropagation();

        handleDeleteCustomer(c.id);
      }}
      className="whitespace-nowrap bg-red-500 hover:bg-red-600 text-white px-5 py-3 rounded-2xl font-medium transition"
    >
      Delete
    </button>

  </div>

</td>

                  </tr>

                ))

              )}

            </tbody>

          </table>

        </div>

        {/* PAGINATION */}

        <div className="px-5 md:px-8 py-5 border-t border-gray-100 flex flex-col md:flex-row justify-between md:items-center gap-4">

          {/* INFO */}

          <p className="text-sm text-gray-500">

            Showing
            {" "}

            <span className="font-semibold text-gray-700">

              {

                filteredCustomers.length === 0

                  ? 0

                  : indexOfFirst + 1
              }

            </span>

            {" "}
            to
            {" "}

            <span className="font-semibold text-gray-700">

              {
                Math.min(
                  indexOfLast,
                  filteredCustomers.length
                )
              }

            </span>

            {" "}
            of
            {" "}

            <span className="font-semibold text-gray-700">

              {filteredCustomers.length}

            </span>

            {" "}
            customers

          </p>

          {/* BUTTONS */}

          <div className="flex gap-2 flex-wrap">

            {/* PREV */}

            <button
              onClick={() =>
                setCurrentPage(prev =>

                  Math.max(
                    prev - 1,
                    1
                  )
                )
              }
              className="px-4 py-2 border border-gray-200 rounded-xl text-sm hover:bg-gray-100 transition"
            >

              Prev

            </button>

            {/* PAGE NUMBERS */}

            {[...Array(totalPages)].map(
              (_, i) => (

                <button
                  key={i}
                  onClick={() =>
                    setCurrentPage(i + 1)
                  }
                  className={`px-4 py-2 text-sm rounded-xl transition

                    ${
                      currentPage === i + 1

                        ? "bg-gradient-to-r from-indigo-600 to-purple-600 text-white shadow"

                        : "border border-gray-200 hover:bg-gray-100"
                    }
                  `}
                >

                  {i + 1}

                </button>

              )
            )}

            {/* NEXT */}

            <button
              onClick={() =>

                setCurrentPage(prev =>

                  Math.min(
                    prev + 1,
                    totalPages
                  )
                )
              }
              className="px-4 py-2 border border-gray-200 rounded-xl text-sm hover:bg-gray-100 transition"
            >

              Next

            </button>

          </div>

        </div>

      </div>

    </div>
  );
};

export default Customers;